var map = {
	"./Magento2.png": 4740,
	"./allegro.png": 351,
	"./amazon.png": 6611,
	"./bigcommerce.png": 364,
	"./bling.png": 4609,
	"./claroshop.png": 6188,
	"./cscart.png": 4163,
	"./default.png": 2608,
	"./ebay.png": 2516,
	"./ecart.png": 6607,
	"./ecwid.png": 35,
	"./etsy.png": 3952,
	"./hybris.png": 5426,
	"./jumpseller.png": 5074,
	"./kometia.png": 8073,
	"./linio.png": 5590,
	"./liverpool.png": 7405,
	"./loja.png": 1431,
	"./magento1.png": 3535,
	"./mercadolibre.png": 7992,
	"./multivende.png": 6596,
	"./nopcommerce.png": 4249,
	"./opencart.png": 4613,
	"./prestashop.png": 676,
	"./quickbooks.png": 3182,
	"./salesforce.png": 4150,
	"./shein.png": 1920,
	"./shiphero.png": 4294,
	"./shoplazza.png": 5077,
	"./squarespace.png": 5766,
	"./tiendanube.png": 2850,
	"./tiny.png": 6781,
	"./unicommerce.png": 5996,
	"./vendhq.png": 9891,
	"./verskis.png": 6474,
	"./vtex.png": 706,
	"./walmart.png": 7971,
	"./woocommerce.png": 6975,
	"./yampi.png": 9013,
	"./zoho.png": 4217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;